import React, { useState } from 'react';
import Card from 'react-bootstrap/Card'

export default function FigureCaption(props) {

    const [captionClasses, setCaptionClasses] = useState({
        full: 'd-none d-md-block',
        truncated: 'd-block d-md-none'
    });

    let expand = (e) => {
        e.preventDefault();
        setCaptionClasses({full: '', truncated: 'd-none'})
    }

    return (
        <div>
            <span class={captionClasses.full}>
                <p style={{fontSize:'10pt'}}>
                    <b>Figure:</b> {props.caption}
                </p>
            </span>
            <span class={captionClasses.truncated}>
                <p style={{fontSize:'10pt'}}>
                    <b>Figure:</b> {props.short_caption}
                    &nbsp;
                    <a href="#" onClick={expand}>(more)</a>
                </p>
            </span>
            <br />
        </div>
    )
}
